// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__dGtkE","closeBtn":"style_closeBtn__WEHyp"};